import React, { useState } from 'react'
import { filterColors } from 'src/utils/styles'
import multiColorIcon from 'src/static/images/multiColourIcon.jpg'
import {
  Container,
  FilterValue,
  StColor,
  StFilterAmount,
  StHeadlineWrapper,
  StMultiColor,
  StOptionContainer,
} from './styles'

export const ColoredFilterList = ({
  title,
  options,
  setSelectedFilters,
  selectedFilters,
  isMobile = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const addFilterValue = value => {
    let tmpFilters = selectedFilters
    tmpFilters = tmpFilters.filter(e => e !== 'all')

    tmpFilters = new Set([...tmpFilters, value])
    setSelectedFilters([...tmpFilters])
  }

  const removeFilterValue = value => {
    let tmpFilters = selectedFilters
    tmpFilters = tmpFilters.filter(e => e !== value)
    if (tmpFilters.length === 0) tmpFilters.push('all')
    setSelectedFilters([...tmpFilters])
  }

  const isOptionSelected = value => {
    return selectedFilters.includes(value)
  }

  function handleKeyDown(event, option) {
    if (event.key === 'Enter') {
      isOptionSelected(option.value)
        ? removeFilterValue(option.value)
        : addFilterValue(option.value)
    }
  }

  return (
    <Container isOpen={isOpen}>
      <StHeadlineWrapper
        onClick={() => setIsOpen(!isOpen)}
        isActive={!selectedFilters.includes('all')}
      >
        {isOpen ? (
          <span style={{ width: '0.25em', fontSize: '16px', marginLeft: '0.25em' }}>&ndash;</span>
        ) : (
          <span style={{ width: '0.25em', fontSize: '16px', marginLeft: '0.25em' }}>+</span>
        )}
        <span style={{ paddingLeft: '1.3rem' }}>{title}</span>
        {!selectedFilters.includes('all') && (
          <StFilterAmount>{selectedFilters.length}</StFilterAmount>
        )}
      </StHeadlineWrapper>
      <StOptionContainer
        isOpen={isOpen}
        isMobile={isMobile}
        optionsCount={isMobile ? options.length / 2 : options.length}
      >
        {options.map(option => {
          if (option.value === 'all') return null
          return (
            <div
              role={'button'}
              tabIndex={0}
              key={option.id + option.value}
              style={{
                position: 'relative',
                marginBottom: '0.25em',
                display: 'flex',
                alignItems: 'center',
                outline: 'none',
              }}
              onClick={() =>
                isOptionSelected(option.value)
                  ? removeFilterValue(option.value)
                  : addFilterValue(option.value)
              }
              onKeyDown={event => handleKeyDown(event, option)}
            >
              {option.value === 'Multicolor' ? (
                <StMultiColor src={multiColorIcon} isActive={isOptionSelected(option.value)} />
              ) : (
                <StColor
                  color={filterColors[option.value]}
                  isActive={isOptionSelected(option.value)}
                />
              )}

              <FilterValue
                onClick={() => addFilterValue(option.value)}
                isActive={isOptionSelected(option.value)}
              >
                {option.label}
              </FilterValue>
            </div>
          )
        })}
      </StOptionContainer>
    </Container>
  )
}
